
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import { objectTransform, storedProcParameters, makeResourceFirst } from "./apiUtils";
import demoParams from '../__test__/demoParams';
import moment from 'moment-timezone';
import getOffsetTime from '../utils/getOffsetTime';
const { demoMode, demoListOfResourceCollectionsUserId } = demoParams;

/**
 * Returns a list of resources in a collection by calling an api that gets the branchId using the userId.
 It then uses the branchId for a second api call to get all the resources in the collection.
 * @param {*String} userId
 */
export async function getListOfResourceCollection(userId) {
    const { companyId } = storedProcParameters;
    const getBranchesByUserId = await API.graphql(graphqlOperation(queries.userApIgetBranch, { userId, companyId }));
    const branchId = getBranchesByUserId.data.userAPIgetBranch.userBranchId;

    let listOfResourceCollection = await API.graphql(graphqlOperation(queries.resourceApIgetResourceCollection,
        {
            userId: demoMode ? demoListOfResourceCollectionsUserId : userId,
            branchId
        }));
    return listOfResourceCollection.data.resourceAPIgetResourceCollection;
}

/**
 *
 * api uses startDate (moment object) to generate unix timestamps
 * for all the items (tours, assignments, meals) in the schedule
 * even passing in a string ('10/17/2020') will work (moment converts it)
 * however we pass a moment object
 * @param {*} startDate
 * @param {*} scheduleFormat
 * @param {*} resourceCollectionId
 * @param {*} userId
 * @param {*} resourceId
 */
export async function getLiveSchedules(
    startDate,
    scheduleFormat,
    resourceCollectionId,
    userId,
    resourceId,
    scheduleView
) {
    
    let sortedLiveScheduleArray;
    let timeZoneOffset = 0;
    //getOffsetTime(startDate._d);
    //startDate = startDate.subtract(timeZoneOffset, 'minutes');
    
    let startDateFormat = startDate._i
    try {
        let liveScheduleArray = await API.graphql(graphqlOperation(
            queries.scheduleApIgetLiveSchedules,
            {
                startDate: startDateFormat,
                scheduleFormat,
                resourceCollectionId,
                userId,
                resourceId,
                scheduleView
            }
        ));

        let labourScheduleArray = liveScheduleArray.data.scheduleAPIgetLiveSchedules.liveSchedule.labourSchedule;
        let facilityScheduleArray = liveScheduleArray.data.scheduleAPIgetLiveSchedules.liveSchedule.facilitySchedule;

        let combinedSchedules = [...labourScheduleArray, ...facilityScheduleArray]
        combinedSchedules = objectTransform(combinedSchedules);

        sortedLiveScheduleArray = combinedSchedules;
    } catch (error) {
        let errorString = '';
        for (let value of error.errors) {
            errorString = errorString + value.message;
        }
        alert(errorString);
    }

    // Readjusting schedule
    startDate = startDate.add(timeZoneOffset, 'minutes');
    startDate = startDate._d;

    const liveSchedule = {
        startDate,
        scheduleFormat,
        resourceCollectionId,
        userId,
        resourceId,
        liveSchedule: sortedLiveScheduleArray
    };

    return liveSchedule;
}



// WEBPACK FOOTER //
// ./src/api/liveScheduleApi.js